module.exports = __webpack_public_path__ + "img/star_C.8f26ad3e.svg";